/**
 * Etykieta czasu trwania (np. na miniaturce / w hero): MM:SS lub H:MM:SS.
 */
export function formatDurationClock(totalSeconds: number): string {
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
    return '';
  }
  const s = Math.floor(totalSeconds);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => (n < 10 ? `0${n}` : String(n));
  if (h > 0) {
    return `${h}:${pad(m)}:${pad(sec)}`;
  }
  return `${m}:${pad(sec)}`;
}

/**
 * Tekst wyświetlany przy dużym playerze: jeśli redakcja wpisała „12:45”, bez dopisku „min”.
 * Samą liczbę (np. „5”) traktujemy jak minuty (stare zachowanie).
 */
export function formatDurationHeroMeta(raw: string): string {
  const t = raw.trim();
  if (!t) {
    return '';
  }
  if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(t)) {
    return t;
  }
  if (/^\d+(\.\d+)?$/.test(t)) {
    return `${t} min`;
  }
  return t;
}
